import {
    Button, Result, ResultProps, Space,
} from 'antd';
import {
    Link, useNavigate,
} from 'react-router-dom';

import { AppRoute } from '@/constants';

type StatusCode = '403' | '404' | '429' | '500' | 'error';

const statusTitles: Record<StatusCode, string> = {
    '403': 'Доступ заборонено',
    '404': 'Сторінка не знайдена',
    '429': 'Занадто багато запитів',
    '500': 'Внутрішня помилка сервера',
    error: 'Невідома помилка',
};

const errorMessages: Record<StatusCode, string> = {
    '403': 'Вибачте, ви не авторизовані для доступу до цієї сторінки.',
    '404': 'Вибачте, сторінка, яку ви відвідали, не існує.',
    '429': 'Вибачте, ви надто часто відправляєте запити. Будь ласка, зачекайте трохи перед повторною спробою.',
    '500': 'Вибачте, щось пішло не так. Повторіть спробу пізніше.',
    error: 'Вибачте, щось пішло не так. Повторіть спробу пізніше.',
};

type ErrorPageProps = {
    statusCode?: StatusCode;
};

export const ErrorPage = ({ statusCode = 'error' }: ErrorPageProps) => {
    const navigate = useNavigate();
    const resultStatus = statusCode === '429' ? 'warning' : statusCode;

    return (
        <Result
            status={resultStatus as ResultProps['status']}
            title={statusTitles[statusCode as keyof typeof statusTitles]}
            subTitle={errorMessages[statusCode as keyof typeof errorMessages]}
            extra={(
                <Space>
                    <Button onClick={() => navigate(-1)}>Назад</Button>
                    <Link to={AppRoute.Root}>
                        <Button type="primary">На головну</Button>
                    </Link>
                </Space>
            )}
        />
    );
};
